import PersonaControl from './PersonaControl';
import React, { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { PersonaControlProps } from './PersonaControl.types';
import { useIsVisibleInViewport } from 'mini-hooks/lib/useIsVisibleInViewport';

const PersonaControlV2 = (props: PersonaControlProps) => {
    const fallbackRef = useRef<HTMLDivElement>(null);
    const personaRef = props.personaRef ?? fallbackRef;
    const { lazyLoadOptions } = props;
    const { lazyLoad, lazyLoadWait } = lazyLoadOptions ?? {};

    const isVisibleInViewport = useIsVisibleInViewport(
        lazyLoad ? personaRef : null,
        lazyLoadWait ?? 400,
        true // Notify only once when visible
    );

    return (
        <PersonaControl
            {...props}
            personaRef={personaRef}
            fetchPhotoOnCacheMiss={lazyLoad ? isVisibleInViewport : true}
        />
    );
};

export default observer(PersonaControlV2);
